export default __webpack_public_path__ + "static/media/refresh-light.e5cdf491.svg";